export class NoRemovalItemsFound extends Error {
  constructor() {
    super(
      'The file(s) you are trying to remove could not be found. This could be because the file names' +
        ' are invalid or the files have not been uploaded to the system.',
    )
    Object.setPrototypeOf(this, NoRemovalItemsFound.prototype)
  }
}
